import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
} from "@mui/material";
import LightTextField from "components/LightTextField";
import {useFormik} from "formik";
import React, {useEffect, useState} from "react";
import * as Yup from "yup";
import {ROLE_TYPES} from "./constants";
import {LoadingButton} from "@mui/lab";
import {createRole, updateRole} from "../../api/role";
import getUpdatedFields from "../../utils/getUpdatedFields";
import {Role} from "../../types/Role";


type CreateRoleDialogProps = {
    open?: boolean,
    onClose?: () => void,
    initialData?: Role,
    onCreateEntityStatusChange?: (state?: "success" | "error", message?: string) => void,
    action?: "create" | "update"
}

const CreateRoleFormDialog = (props: CreateRoleDialogProps) => {
    const [saving, setSaving] = useState(false)
    const roleTypeMap: { [key in Role['type']]: string } = {
        user: "Utilisateur",
        driver: "Conducteur",
        admin: "Administrateur"
    }

    const handleCloseDialog = () => {
        values = {}
        props.onClose()
    }

    const handlePostCreateSuccess = () => {
        props.onCreateEntityStatusChange("success")
        setSaving(false)
        handleCloseDialog()
    }

    const handlePostCreateError = (reason) => {
        props.onCreateEntityStatusChange("error", reason)
        setSaving(false)
        if (props.action === "update")
            handleCloseDialog()
    }


    const initialValues: Role = {
        name: props.initialData?.name,
        type: props.initialData?.type || "user",
    }

    const handleSaveRole = async (e?: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        setSaving(true)
        if (props.action === "update")
            updateRole(props.initialData.id, getUpdatedFields(props.initialData, values))
                .then(handlePostCreateSuccess)
                .catch(handlePostCreateError)
        else
            createRole(values)
                .then(handlePostCreateSuccess)
                .catch(handlePostCreateError)
    }

    const mainValidationSchema = Yup.object().shape({
        name: Yup.string().required("Ce champs est obligatoire"),
        type: Yup.string().required("Ce champs est obligatoire"),
    })


    let {values, errors, handleChange, validateForm, isValid, handleSubmit, touched} = useFormik({
        initialValues,
        validationSchema: mainValidationSchema,
        onSubmit: () => {

        }
    })

    return (
        <Dialog
            maxWidth={"md"}
            open={props.open}
            onClose={props.onClose}>
            <DialogTitle sx={{fontSize: "large"}}>Créer un rôle</DialogTitle>
            <Divider/>
            <DialogContent>
                <Grid container spacing={3}>
                    <Grid item>
                        <form onSubmit={handleSaveRole} id={"role-form"}>

                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <LightTextField
                                        fullWidth
                                        name="name"
                                        placeholder="Nom du Rôle"
                                        required
                                        value={values.name}
                                        onChange={handleChange}
                                        error={Boolean(touched.name && errors.name)}
                                        helperText={touched.name && errors.name}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Type de rôle</InputLabel>
                                        <Select value={values.type} sx={{textTransform: "capitalize"}}
                                                onChange={handleChange} name={"type"}
                                                input={<OutlinedInput id="select-multiple-chip" label="Role Type"/>}
                                                label="Role Type">
                                            {ROLE_TYPES.map(value =>
                                                <MenuItem sx={{textTransform: "capitalize"}}
                                                          value={value}>{roleTypeMap[value]}</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                </Grid>

                            </Grid>
                        </form>
                    </Grid>
                </Grid>
            </DialogContent>
            <Divider/>
            <DialogActions>
                <Button variant={"outlined"} onClick={handleCloseDialog}>Annuler</Button>
                <LoadingButton type="submit" variant="contained" form={"role-form"} loading={saving}>
                    Enregistrer le rôle
                </LoadingButton>
            </DialogActions>

        </Dialog>
    )
}

export default CreateRoleFormDialog
